"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Center = _interopRequireDefault(require("./Center"));

var _Wrap = _interopRequireDefault(require("./Wrap"));

var _Sidebar = _interopRequireDefault(require("./Sidebar"));

var _Stack = _interopRequireDefault(require("./Stack"));

var _Auto = _interopRequireDefault(require("./Auto"));

var _SpaceBetween = _interopRequireDefault(require("./SpaceBetween"));

var _Clamp = _interopRequireDefault(require("./Clamp"));

var _excluded = ["type", "children"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var QuickLayout = function QuickLayout(_ref) {
  var type = _ref.type,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  switch (type) {
    /**
     * @description This component centers the children horizontally and vertically within the component.
     * @param {string} className - A classname to be added for extra control, if needed.
     */
    case 'center':
      {
        return /*#__PURE__*/_react.default.createElement(_Center.default, null, children);
      }

    /**
     * @description This component renders a common layout for sites, for example, a row of 3 items,
     * usually with an image, title, and then some text, describing some features of a product, or a teaser.
     * On mobile, we want those to stack nicely, and expand as we increase the screen size.
     *
     * @param {string} min - the minimal width of the normal display.
     * @param {string} className - A classname to be added for extra control, if needed.
     * @param {boolean} stretched - if the children can stretch over the parent width.
     */

    case 'wrap':
      {
        return /*#__PURE__*/_react.default.createElement(_Wrap.default, props, children);
      }

    /**
     * @description This component sets the minimum sidebar size to be the min variable,
     * but on larger screens let the sidebar stretch out to the max variable.
     * The sidebar will always take up the max variable of its parent's horizontal space until that max variable becomes smaller than the min variable.
     *
     * @param {string} min - The minimal width of the sidebar.
     * @param {string} className - A classname to be added for extra control, if needed.
     * @param {string} max - The maximal width of the sidebar.
     */

    case 'sidebar':
      {
        return /*#__PURE__*/_react.default.createElement(_Sidebar.default, props, children);
      }

    /**
     * @description This component does the following to it's children:
     * The first child will get the height of its children.
     * The second child will become the main body, and will fill up the remaining height of the parent.
     * The third child will get the height of its children.
     *
     * @param {string} className - A classname to be added for extra control, if needed.
     */

    case 'stack':
      {
        return /*#__PURE__*/_react.default.createElement(_Stack.default, props, children);
      }

    /**
     * @description This component allows its children to be automatically placed within a grid and scaled, a min width is given to set the minimum width.
     * @param {string} min - The minimal width of the default display.
     * @param {string} gap - The space between items.
     * @param {string} className - A classname to be added for extra control, if needed.
     */

    case 'auto':
      {
        return /*#__PURE__*/_react.default.createElement(_Auto.default, props, children);
      }

    /**
     * @description This component makes sure the children are positioned space-between eachother according to
     * the max width of the parent.
     *
     * @param {string} gap - The space between items.
     * @param {string} items - The amount of items.
     * @param {string} className - A classname to be added for extra control, if needed.
     *
     * @note Only use this when the amount of items is known to you. Use QuickLayoutAuto otherwise.
     */

    case 'spaceBetween':
      {
        return /*#__PURE__*/_react.default.createElement(_SpaceBetween.default, props, children);
      }

    /**
     * @description This component allows the automatic scaling of font-sizes.
     * @param {string} min - The minimal font-size.
     * @param {string} value - The value of the font-size. NOTE: This should be in viewportwidth (vw) units.
     * @param {string} max - The maximal font-size.
     * @param {string} className - A classname to be added for extra control, if needed.
     */

    case 'clamp':
      {
        return /*#__PURE__*/_react.default.createElement(_Clamp.default, props, children);
      }

    default:
      {
        return 'No type selected.';
      }
  }
};

QuickLayout.defaultProps = {
  type: ''
};
var _default = QuickLayout;
exports.default = _default;